module.exports = __webpack_public_path__ + "static/media/image18.900e6a50.png";